module.exports = __webpack_public_path__ + "sin-down.png?076fe37ec850130ba37ce28c8778a2a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sin-down.png
// module id = 10
// module chunks = 0